// Mock data for Fryd! woodwork company

export const companyInfo = {
  name: "Fryd!",
  tagline: "Vi realiserer arkitektens vision – præcist som den er tænkt og tegnet",
  description: "Fryd! er et dansk tømrer- og snedkerfirma, der skaber løsninger i træ med kompromisløs kvalitet som grundregel. Alt bliver produceret på vores eget værksted her i Danmark - ingen standardløsninger, ingen genveje, ingen masseproduktion. Kun solidt håndværk, udført af fagfolk der brænder for deres materiale.",
  fullDescription: "Vi arbejder med alt fra renovering, trapper, vinduer, døre og gulve til inventar, udhuse, legehuse og specialfremstillede møbler. Uanset projektets størrelse får du samme gennemførte finish og samme omhu i hver eneste detalje. Hos Fryd er træ ikke blot et materiale. Det er et ansvar - og en passion. Derfor prioriterer vi godt råtræ, stærke konstruktioner og lang levetid i alt, vi leverer. Vi bygger det, vi kan stå inde for. Det, der holder. Det, du kan være stolt af i mange år. Hvis du ønsker en løsning, der ikke bare fungerer, men føles rigtigt - æstetisk, praktisk og håndværksmæssigt - så bygger vi den.",
  services: [
    "Renovering",
    "Trapper",
    "Vinduer",
    "Døre",
    "Gulve",
    "Inventar",
    "Udhuse",
    "Legehuse",
    "Specialfremstillede møbler"
  ],
  contact: {
    owner: "Jonas Hemicke",
    address: "Mesterlodden 26",
    city: "2820 Gentofte",
    phone: "30 11 03 51",
    email: "jh@ffryd.dk",
    cvr: "37765104"
  },
  social: {
    facebook: "https://da-dk.facebook.com/Frydtomrer/",
    linkedin: "https://dk.linkedin.com/in/jonas-hemicke-477082b2",
    instagram: "https://www.instagram.com/fryd_tomrerfirma/"
  }
};

// Grouped projects with metadata for individual project pages
export const projectsGrouped = [
  {
    id: "tolvkanten",
    slug: "tolvkanten",
    title: "Tolvkanten",
    seoTitle: "Tolvkanten / Tiny Church i Nordhavn | Fryd!",
    seoDescription: "Se Tolvkanten, også kendt som Tiny Church, i Nordhavn. En tolvkantet ceremonikirke tegnet af Julius Nielsen og opført af Fryd!",
    description: "I Nordhavn har vi opført Tiny Church, en tolvkantet ceremonikirke tegnet af arkitekt Julius Nielsen for Hans Egedes Kirke.\n\nBygningen er opført med fokus på biogene materialer og et lavt CO₂-aftryk. Bag den sorte træfacade åbner et lyst kirkerum sig med gennemgående træbeklædning, ovenlys og en arkitektur, hvor materialer og proportioner er i centrum.\n\nTiny Church stod færdig i 2025 og danner i dag ramme om både kirkelige ceremonier og kulturelle arrangementer.",
    projectInfo: {
      projectName: "Tolvkanten / Tiny Church",
      architect: "Julius Nielsen",
      client: "Hans Egedes Kirke",
      location: "Nordhavn, København",
      year: "2025",
      sourceUrl: "https://www.hansegedeskirke.dk/tiny-church",
      sourceName: "Hans Egedes Kirke"
    },
    images: [
      "https://customer-assets.emergentagent.com/job_crafted-timber/artifacts/ilroiuov_Tolvkanten_Juni16_FotoHampusBerndtson_high.jpg",
      "https://customer-assets.emergentagent.com/job_crafted-timber/artifacts/mgknccnb_Tolvkanten_Juni15_FotoHampusBerndtson_high.jpg"
    ],
    isPublic: true,
    order: 1
  },
  {
    id: "projekt-3",
    slug: "projekt-3",
    title: "Privat projekt",
    description: "",
    images: [
      "https://customer-assets.emergentagent.com/job_crafted-timber/artifacts/g2gawzw5_IMG_0010%20%284%29.jpg",
      "https://customer-assets.emergentagent.com/job_crafted-timber/artifacts/1b5qv5j5_IMG_0006%20%284%29.jpg"
    ],
    isPublic: false,
    order: 2
  },
  {
    id: "zoolab",
    slug: "zoolab",
    title: "ZooLab",
    seoTitle: "ZooLab i Zoologisk Have | Fryd! Tømrer & Snedker",
    seoDescription: "Fryd! var hovedentreprenør på ZooLab i Københavns Zoologiske Have, en formidlingsbygning på 265 m² tegnet af Claus Pryds Arkitekter.",
    description: "For Københavns Zoologiske Have har vi været hovedentreprenør på ZooLab, en formidlingsbygning tegnet af Claus Pryds Arkitekter.\n\nBygningen er opført med en bærende trækonstruktion, sortmalet træbeklædning og store tagflader. Indvendigt skaber krydsfiner i fyr en varm kontrast til det mørke ydre.\n\nZooLab stod færdig i 2020 og rummer 265 m² med plads til undervisning, nysgerrighed og formidling af dyreliv og natur.",
    projectInfo: {
      projectName: "ZooLab",
      architect: "Claus Pryds Arkitekter",
      role: "Hovedentreprenør",
      location: "Zoologisk Have, København",
      year: "2020",
      area: "265 m²",
      sourceUrl: "https://www.clauspryds.dk/projekter/zoolab",
      sourceName: "Claus Pryds Arkitekter"
    },
    images: [
      "https://customer-assets.emergentagent.com/job_crafted-timber/artifacts/7q3tqx0c_Billede%2020.01.2020%2017.52.47.jpg",
      "https://customer-assets.emergentagent.com/job_crafted-timber/artifacts/gbx4ax4r_Zoolab.jpg"
    ],
    isPublic: true,
    order: 3
  },
  {
    id: "store-taarn",
    slug: "store-taarn",
    title: "Store Tårn",
    seoTitle: "Store Tårn på Christiansø | Fryd! Tømrer & Snedker",
    seoDescription: "Fryd! har været en del af restaureringen af Store Tårn på Christiansø, et fæstningsværk fra 1600-tallet tegnet af arkitekt Mette Maegaard Nielsen.",
    description: "På Christiansø har vi været en del af restaureringen af Store Tårn, et historisk fæstningsværk fra 1600-tallet.\n\nProjektet er tegnet af arkitekt Mette Maegaard Nielsen og forener bevaring af den oprindelige arkitektur med nye funktioner. En diskret glasoverdækning og et indskudt dæk har skabt nye rum til kunst og kulturelle oplevelser, samtidig med at tårnets historiske karakter er bevaret.\n\nRestaureringen blev afsluttet i 2017.",
    projectInfo: {
      architect: "Mette Maegaard Nielsen",
      location: "Christiansø",
      period: "2014-2017",
      sourceUrl: "https://realdania.dk/projekter/store-taarn-christiansoe",
      sourceName: "Realdania"
    },
    images: [
      "https://customer-assets.emergentagent.com/job_crafted-timber/artifacts/947gttur__MG_7220%20%284%29.jpg",
      "https://customer-assets.emergentagent.com/job_crafted-timber/artifacts/2clr3lnc__MG_7332%20%284%29.jpg"
    ],
    isPublic: true,
    order: 4
  },
  {
    id: "projekt-9",
    slug: "projekt-9",
    title: "Privat projekt",
    description: "",
    images: [
      "https://customer-assets.emergentagent.com/job_crafted-timber/artifacts/lnttpjhj_ChatGPT%20Image%203.%20dec.%202025%2010.07.44.png",
      "https://customer-assets.emergentagent.com/job_crafted-timber/artifacts/s651j0wc_ChatGPT%20Image%203.%20dec.%202025%2010.14.11.png"
    ],
    isPublic: false,
    order: 5
  },
  {
    id: "projekt-11",
    slug: "projekt-11",
    title: "Privat projekt",
    description: "",
    images: [
      "https://customer-assets.emergentagent.com/job_crafted-timber/artifacts/hjeri1gh_20160930_085306.jpg",
      "https://customer-assets.emergentagent.com/job_crafted-timber/artifacts/1t71mdbm_20160930_085114.jpg"
    ],
    isPublic: false,
    order: 6
  },
  {
    id: "rosenborg",
    slug: "rosenborg",
    title: "Rosenborg",
    description: "",
    images: [
      "https://customer-assets.emergentagent.com/job_crafted-timber/artifacts/s6tnstxq_IMG_3709.JPG",
      "https://customer-assets.emergentagent.com/job_crafted-timber/artifacts/0wmmjteq_IMG_3716.JPG"
    ],
    isPublic: true,
    order: 7
  },
  {
    id: "projekt-15",
    slug: "projekt-15",
    title: "Privat projekt",
    description: "",
    images: [
      "https://customer-assets.emergentagent.com/job_crafted-timber/artifacts/fcfrsiux__MG_6541.jpg",
      "https://customer-assets.emergentagent.com/job_crafted-timber/artifacts/ib0qo8wz__MG_6624.jpg"
    ],
    isPublic: false,
    order: 8
  },
  {
    id: "projekt-17",
    slug: "projekt-17",
    title: "Privat projekt",
    description: "",
    images: [
      "https://customer-assets.emergentagent.com/job_crafted-timber/artifacts/hdhnc74r_reol020518_fryd_valde_3.JPG",
      "https://customer-assets.emergentagent.com/job_crafted-timber/artifacts/quit3qwr_reol020518_fryd_valde_2.JPG"
    ],
    isPublic: false,
    order: 9
  },
  {
    id: "zoologisk-have",
    slug: "zoologisk-have",
    title: "Zoologisk Have",
    description: "",
    images: [
      "https://customer-assets.emergentagent.com/job_crafted-timber/artifacts/24k70rvj_zoo240519_fryd_valde_3.JPG",
      "https://customer-assets.emergentagent.com/job_crafted-timber/artifacts/w6slgb36_zoo240519_fryd_valde_4.JPG"
    ],
    isPublic: true,
    order: 10
  }
];

// Legacy format for backwards compatibility with existing Projects.jsx grid display
// This shows all images individually in the 2-column grid
export const projects = [
  {
    id: 1,
    title: "Tolvkanten",
    location: "Tolvkanten",
    slug: "tolvkanten",
    image: "https://customer-assets.emergentagent.com/job_crafted-timber/artifacts/ilroiuov_Tolvkanten_Juni16_FotoHampusBerndtson_high.jpg"
  },
  {
    id: 2,
    title: "",
    location: "",
    slug: "tolvkanten",
    image: "https://customer-assets.emergentagent.com/job_crafted-timber/artifacts/mgknccnb_Tolvkanten_Juni15_FotoHampusBerndtson_high.jpg"
  },
  {
    id: 3,
    title: "Privat projekt",
    location: "Privat projekt",
    slug: "projekt-3",
    image: "https://customer-assets.emergentagent.com/job_crafted-timber/artifacts/g2gawzw5_IMG_0010%20%284%29.jpg"
  },
  {
    id: 4,
    title: "",
    location: "",
    slug: "projekt-3",
    image: "https://customer-assets.emergentagent.com/job_crafted-timber/artifacts/1b5qv5j5_IMG_0006%20%284%29.jpg"
  },
  {
    id: 5,
    title: "ZooLab",
    location: "ZooLab",
    slug: "zoolab",
    image: "https://customer-assets.emergentagent.com/job_crafted-timber/artifacts/7q3tqx0c_Billede%2020.01.2020%2017.52.47.jpg"
  },
  {
    id: 6,
    title: "",
    location: "",
    slug: "zoolab",
    image: "https://customer-assets.emergentagent.com/job_crafted-timber/artifacts/gbx4ax4r_Zoolab.jpg"
  },
  {
    id: 7,
    title: "Store Tårn",
    location: "Store Tårn",
    slug: "store-taarn",
    image: "https://customer-assets.emergentagent.com/job_crafted-timber/artifacts/947gttur__MG_7220%20%284%29.jpg"
  },
  {
    id: 8,
    title: "",
    location: "",
    slug: "store-taarn",
    image: "https://customer-assets.emergentagent.com/job_crafted-timber/artifacts/2clr3lnc__MG_7332%20%284%29.jpg"
  },
  {
    id: 9,
    title: "Privat projekt",
    location: "Privat projekt",
    slug: "projekt-9",
    image: "https://customer-assets.emergentagent.com/job_crafted-timber/artifacts/lnttpjhj_ChatGPT%20Image%203.%20dec.%202025%2010.07.44.png"
  },
  {
    id: 10,
    title: "",
    location: "",
    slug: "projekt-9",
    image: "https://customer-assets.emergentagent.com/job_crafted-timber/artifacts/s651j0wc_ChatGPT%20Image%203.%20dec.%202025%2010.14.11.png"
  },
  {
    id: 11,
    title: "Privat projekt",
    location: "Privat projekt",
    slug: "projekt-11",
    image: "https://customer-assets.emergentagent.com/job_crafted-timber/artifacts/hjeri1gh_20160930_085306.jpg"
  },
  {
    id: 12,
    title: "",
    location: "",
    slug: "projekt-11",
    image: "https://customer-assets.emergentagent.com/job_crafted-timber/artifacts/1t71mdbm_20160930_085114.jpg"
  },
  {
    id: 13,
    title: "Rosenborg",
    location: "Rosenborg",
    slug: "rosenborg",
    image: "https://customer-assets.emergentagent.com/job_crafted-timber/artifacts/s6tnstxq_IMG_3709.JPG"
  },
  {
    id: 14,
    title: "",
    location: "",
    slug: "rosenborg",
    image: "https://customer-assets.emergentagent.com/job_crafted-timber/artifacts/0wmmjteq_IMG_3716.JPG"
  },
  {
    id: 15,
    title: "Privat projekt",
    location: "Privat projekt",
    slug: "projekt-15",
    image: "https://customer-assets.emergentagent.com/job_crafted-timber/artifacts/fcfrsiux__MG_6541.jpg"
  },
  {
    id: 16,
    title: "",
    location: "",
    slug: "projekt-15",
    image: "https://customer-assets.emergentagent.com/job_crafted-timber/artifacts/ib0qo8wz__MG_6624.jpg"
  },
  {
    id: 17,
    title: "Privat projekt",
    location: "Privat projekt",
    slug: "projekt-17",
    image: "https://customer-assets.emergentagent.com/job_crafted-timber/artifacts/hdhnc74r_reol020518_fryd_valde_3.JPG"
  },
  {
    id: 18,
    title: "",
    location: "",
    slug: "projekt-17",
    image: "https://customer-assets.emergentagent.com/job_crafted-timber/artifacts/quit3qwr_reol020518_fryd_valde_2.JPG"
  },
  {
    id: 19,
    title: "Zoologisk Have",
    location: "Zoologisk Have",
    slug: "zoologisk-have",
    image: "https://customer-assets.emergentagent.com/job_crafted-timber/artifacts/24k70rvj_zoo240519_fryd_valde_3.JPG"
  },
  {
    id: 20,
    title: "",
    location: "",
    slug: "zoologisk-have",
    image: "https://customer-assets.emergentagent.com/job_crafted-timber/artifacts/w6slgb36_zoo240519_fryd_valde_4.JPG"
  }
];

export const aboutImages = [
  "https://customer-assets.emergentagent.com/job_crafted-timber/artifacts/qfxi0gf3_OM.jpg",
  "https://customer-assets.emergentagent.com/job_crafted-timber/artifacts/7yby53ew_IMG_0010%20%284%29.jpg"
];
